// src/hooks/useCreateUser.ts
import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { RootState } from '../../redux';
import { createUser } from '../../redux/user/userSlice';
/**
 * Custom hook to encapsulate dispatching the createUser thunk
 * and reading loading / error / result from Redux state.
 */
export default function useCreateUser() {
 
  const dispatch = useDispatch();
  const { user, isLoading, error } = useSelector((state: RootState) => state.user);

  // A memoized function to dispatch createUser
  const createUserDb = useCallback(
    async (userData: any ) => {
      const result = await dispatch(createUser(userData) as any);
      return result.payload; // Return the actual user data
    },
    [dispatch]
  );

  return {
    createUserDb,
    user,
    isLoading,
    error,
  };
}
